"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var Utilities_1 = require("../../Utilities");
var stylesImport = require("./Overlay.scss");
var styles = stylesImport;
var Overlay = (function (_super) {
    tslib_1.__extends(Overlay, _super);
    function Overlay() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Overlay.prototype.componentDidMount = function () {
        Utilities_1.disableBodyScroll();
    };
    Overlay.prototype.componentWillUnmount = function () {
        Utilities_1.enableBodyScroll();
    };
    Overlay.prototype.render = function () {
        var _a = this.props, isDarkThemed = _a.isDarkThemed, className = _a.className;
        var divProps = Utilities_1.getNativeProps(this.props, Utilities_1.divProperties);
        var modifiedClassName = Utilities_1.css('ms-Overlay', styles.root, className, (_b = {},
            _b['ms-Overlay--dark ' + styles.rootIsDark] = isDarkThemed,
            _b));
        return (React.createElement("div", tslib_1.__assign({}, divProps, { className: modifiedClassName })));
        var _b;
    };
    return Overlay;
}(Utilities_1.BaseComponent));
exports.Overlay = Overlay;
//# sourceMappingURL=Overlay.js.map


//////////////////
// WEBPACK FOOTER
// ../~/office-ui-fabric-react/lib/components/Overlay/Overlay.js
// module id = ../node_modules/office-ui-fabric-react/lib/components/Overlay/Overlay.js
// module chunks = 1